import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import { authReducer } from './slices/authSlice';
import { themeReducer } from './slices/themeSlice';
import { commandBarReducer } from './slices/commandBarSlice';
import { baseApi } from './api/baseApi';

export const rootReducer = combineReducers({
  auth: authReducer,
  theme: themeReducer,
  commandBar: commandBarReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
